// Availability is managed in App.jsx; this catalog keeps vacancy links and labels consistent.
export const jobCatalog = [
    {
        id: "inspecteurScope12",
        title: "Inspecteur Zonnepanelen / Scope 12",
        path: "/vacature/inspecteur-zonnepanelen-scope-12",
        hours: "40 uur",
        education: "MBO",
        location: "Maasdijk",
        category: "Techniek",
        description:
            "Ben jij een technisch onderlegde elektromonteur met een oog voor details? En wil jij graag een belangrijke rol spelen in het waarborgen van veiligheid, kwaliteit en efficiëntie? Dan zijn wij op zoek naar jou!",
    },
    {
        id: "accountManagerZonnepanelen",
        title: "Account Manager Zonnepanelen",
        path: "/vacature/account-manager-zonnepanelen",
        hours: "40 uur",
        education: "MBO",
        location: "Maasdijk",
        category: "Commercieel",
        description:
            "Dagelijks adviseer je klanten over de mogelijkheden om energiebesparingen te realiseren. Je verdiept je vooraf goed in de woonsituatie en de wensen van de klant en beoordeelt met welke toepassing je het beste resultaat kunt bereiken. Je overlegt met collega’s van werkvoorbereiding voordat je de offerte de deur uit doet. Je neemt vervolgens de aanbieding door met de klant en past deze indien nodig aan...",
    },
    {
        id: "administratiefMedewerkerInkoop",
        title: "Administratief medewerker inkoop",
        path: "/vacature/administratief-medewerker-inkoop",
        hours: "32-40 uur",
        education: "MBO",
        location: "Maasdijk",
        category: "Organisatie",
        description:
            "Ben jij gestructureerd en hou je van een puzzel als het gaat om uitzoeken van materialen en voorraden beheren? Ga dan aan de slag als administratief medewerker inkoop bij Smith Solar B.V.",
    },
    {
        id: "afterSalesCoordinator",
        title: "After Sales Coördinator",
        path: "/vacature/after-sales-coordinator",
        hours: "40 uur",
        education: "MBO",
        location: "Maasdijk",
        category: "Organisatie",
        description:
            "Ben jij een problemenoplosser pur sang en heb je affiniteit met elektrotechniek? En wil jij graag aan de slag binnen een informeel bedrijf in een zelfstandige rol? Dan zijn wij op zoek naar jou!",
    },
    {
        id: "commercieelMedewerkerBinnendienst",
        title: "Commercieel Medewerker Binnendienst",
        path: "/vacature/commercieel-medewerker-binnendienst",
        hours: "32-40 uur",
        education: "MBO",
        location: "Maasdijk",
        category: "Commercieel",
        description:
            "Ter versterking van ons team op kantoor zijn wij op zoek naar een Commercieël Medewerker Binnendienst. Kan jij onze potentiële klanten overtuigen van ons product zodat ze daadwerkelijk klant worden? Ben jij 32-40 uur beschikbaar? Dan zijn wij op zoek naar jou!",
    },
    {
        id: "verkoopBinnendienst",
        title: "Commerciële tijger",
        path: "/vacature/verkoop-binnendienst",
        hours: "40 uur",
        education: "MBO",
        location: "Maasdijk",
        category: "Commercieel",
        description:
            "Ter versterking van ons team op kantoor zijn wij op zoek naar een commerciële tijger met haar op de tanden. Kan jij op z’n Westlands onze potentiële klanten overtuigen van ons product zodat ze daadwerkelijk klant worden? Dan zijn wij op zoek naar jou!",
    },
    {
        id: "verkoopBinnendienst24uur",
        title: "Commerciële tijger",
        path: "/vacature/verkoop-binnendienst-24-uur",
        hours: "Vanaf 24 uur",
        education: "MBO",
        location: "Maasdijk",
        category: "Commercieel",
        description:
            "Ter versterking van ons team op kantoor zijn wij op zoek naar een commerciële tijger met haar op de tanden. Kan jij op z’n Westlands onze potentiële klanten overtuigen van ons product zodat ze daadwerkelijk klant worden? Dan zijn wij op zoek naar jou!",
    },
    {
        id: "elektromonteur",
        title: "Elektromonteur",
        path: "/vacature/elektromonteur",
        hours: "40 uur",
        education: "VMBO",
        location: "Maasdijk",
        category: "Techniek",
        description:
            "In deze functie ligt de nadruk op de installatie van zonnepanelen. Dit zowel bij particulieren als bij zakelijke klanten. Het is aan jou om de reeds voorbereide werkzaamheden te vertalen naar goed werkende systemen...",
    },
    {
        id: "hulpMonteurElektrotechniek",
        title: "Hulp monteur Elektrotechniek",
        path: "/vacature/hulp-monteur-elektrotechniek",
        hours: "40 uur",
        education: "VMBO",
        location: "Maasdijk",
        category: "Techniek",
        description:
            "Als Assistent Elektromonteur heb je een belangrijke, ondersteunende taak. Samen met de zelfstandig werkende Elektromonteurs verzorg je de volledige installatie van de elektrotechnische installaties die door ons worden ontwikkeld. Het is aan jou om de door ons ontwikkelde oplossingen te vertalen naar goed werkende systemen. Omdat je afwisselend werkt met zwakstroom, sterkstroom, klimaattechniek en beveiligingstechniek, doe je snel veel ervaring op: afwisseling is dus gegarandeerd!",
    },
    {
        id: "magazijnMedewerker",
        title: "Geordende Magazijnmedewerker",
        path: "/vacature/magazijnmedewerker",
        hours: "40 uur",
        education: "MBO",
        location: "Maasdijk",
        category: "Organisatie",
        description:
            "In deze functie ben jij de baas in het magazijn! Je gaat lekker zelfstandig aan het werk voor 40 uur per week. Zoek jij dus een baan vol afwisseling waar je lekker praktisch bezig bent dan hoef je niet verder te zoeken. Lees snel verder!",
    },
    {
        id: "werkvoorbereiderElektromonteur",
        title: "Werkvoorbereider / Elektromonteur die door wil groeien",
        path: "/vacature/werkvoorbereider-elektromonteur",
        hours: "40 uur",
        education: "MBO",
        location: "Maasdijk",
        category: "Techniek",
        description:
            "Als werkvoorbereider organiseer je alles voor je collega’s op de werkvloer ter voorbereiding van alle installatietechnische projecten: werktekeningen, uittrekstaten, materiaal en materieel etc. Zowel voor tuinbouwtechnische projecten als de zonnepanelen. Monteurs worden blij van je werkinstructies en weten je te vinden bij een technische vraag. Daarnaast zit je bovenop deadlines en budgetten.",
    },
    {
        id: "werkvoorbereiderPlanner",
        title: "Werkvoorbereider / Planner",
        path: "/vacature/werkvoorbereider-planner",
        hours: "40 uur",
        education: "MBO",
        location: "Maasdijk",
        category: "Techniek",
        description:
            "Ben jij gestructureerd en hou je van een puzzel als het gaat om het uitzoeken van materialen en voorraden beheren? Ga dan aan de slag binnen deze veelzijdige rol als Werkvoorbereider / Planner bij Smith Solar B.V.",
    },
    {
        id: "tekenaarWerkvoorbereiderInstallatietechniek",
        title: "Tekenaar / Werkvoorbereider Installatietechniek",
        path: "/vacature/tekenaar-werkvoorbereider-installatietechniek",
        hours: "40 uur",
        education: "MBO",
        location: "Maasdijk",
        category: "Techniek",
        description:
            "Ben jij een Elektromonteur met ambitie, die door wil groeien naar onze vacature van Werkvoorbereider/Tekenaar in een uitdagende omgeving? Wil je graag aan de slag binnen een informeel bedrijf in een zelfstandige rol? Dan zijn wij op zoek naar jou!",
    },
    {
        id: "werkvoorbereider",
        title: "Werkvoorbereider",
        path: "/vacature/werkvoorbereider",
        hours: "40 uur",
        education: "MBO",
        location: "Maasdijk",
        category: "Techniek",
        description:
            "Ben jij gestructureerd en hou je van een puzzel als het gaat om het uitzoeken van materialen en voorraden beheren? Ga dan aan de slag binnen deze veelzijdige rol als Werkvoorbereider / Planner bij Smith Solar B.V.",
    },
];

export const getAvailableJobs = (availability) =>
    jobCatalog.filter((job) => availability[job.id]);
